'use strict';
'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _create = require('babel-runtime/core-js/object/create');

var _create2 = _interopRequireDefault(_create);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _Logger = require('@/libs/Logger');

var _Logger2 = _interopRequireDefault(_Logger);

var _BouncerMiddleware = require('@/libs/BouncerMiddleware');

var _BouncerMiddleware2 = _interopRequireDefault(_BouncerMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var log = _Logger2.default.namespace('BouncerProvider.js');

var BouncerProvider = function () {
    function BouncerProvider(state) {
        (0, _classCallCheck3.default)(this, BouncerProvider);

        this.state = state;

        this.controllerNetwork = null;

        this.bnc = {
            enabled: false,
            username: '',
            password: '',
            server: '',
            port: 6667,
            tls: false,
            direct: false,
            path: '',
            registered: false
        };

        this.rewriteConnections = true;

        this.networksSnapshot = (0, _create2.default)(null);

        state.$on('irc.motd', this.onNetworkMotd.bind(this));
    }

    (0, _createClass3.default)(BouncerProvider, [{
        key: 'enable',
        value: function enable(server, port, tls, direct, path) {
            this.bnc.server = server;
            this.bnc.port = port || 6667;
            this.bnc.tls = !!tls;
            this.bnc.direct = !!direct;
            this.bnc.path = path || '';
            this.bnc.enabled = true;

            this.listenToState();
        }
    }, {
        key: 'getController',
        value: function getController() {
            if (this.controllerNetwork && this.controllerNetwork.state === 'connected') {
                return this.controllerNetwork;
            }

            this.controllerNetwork = null;
            for (var i = 0; i < this.state.networks.length; i++) {
                var network = this.state.networks[i];
                var client = network.ircClient;
                if (network.state === 'connected' && client.network.cap.isEnabled('bouncer')) {
                    this.controllerNetwork = network;
                    break;
                }
            }

            return this.controllerNetwork;
        }
    }, {
        key: 'onNetworkMotd',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(event, network) {
                var client, _network$password$spl, _network$password$spl2, username, password;

                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                client = network.ircClient;

                                if (this.bnc.enabled) {
                                    _context.next = 3;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 3:
                                if (client.network.cap.isEnabled('bouncer')) {
                                    _context.next = 5;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 5:
                                if (client.bnc.hasNetwork() && !network.connection.bncname) {
                                    network.connection.bncname = client.bnc.tags().network;
                                }

                                if (!this.bnc.username) {
                                    _network$password$spl = network.password.split(':'), _network$password$spl2 = (0, _slicedToArray3.default)(_network$password$spl, 2), username = _network$password$spl2[0], password = _network$password$spl2[1];

                                    username = username.split('/')[0];
                                    this.bnc.username = username;
                                    this.bnc.password = password;
                                }

                                if (!client.bnc.hasNetwork()) {
                                    _context.next = 10;
                                    break;
                                }

                                _context.next = 10;
                                return this.syncBncNetwork(network);

                            case 10:
                                _context.next = 12;
                                return this.initAndAddNetworks(network);

                            case 12:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function onNetworkMotd(_x, _x2) {
                return _ref.apply(this, arguments);
            }

            return onNetworkMotd;
        }()
    }, {
        key: 'initAndAddNetworks',
        value: function () {
            var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(network) {
                var _this = this;

                var client, bncNetworks;
                return _regenerator2.default.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                client = network.ircClient;


                                this.bnc.registered = true;

                                if (!network.ircClient.bnc.hasNetwork()) {
                                    network.hidden = true;
                                } else {
                                    network.hidden = false;
                                }

                                _context2.next = 5;
                                return client.bnc.getNetworks();

                            case 5:
                                bncNetworks = _context2.sent;

                                bncNetworks.forEach(function (bncNet) {
                                    return _this.addNetworkToState(bncNet);
                                });

                                this.monitorNetworkChanges();

                            case 8:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function initAndAddNetworks(_x3) {
                return _ref2.apply(this, arguments);
            }

            return initAndAddNetworks;
        }()
    }, {
        key: 'syncBncNetwork',
        value: function () {
            var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(bncNetwork) {
                var _this2 = this;

                var client, buffers;
                return _regenerator2.default.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                client = bncNetwork.ircClient;
                                _context3.next = 3;
                                return client.bnc.getBuffers(bncNetwork.connection.bncname);

                            case 3:
                                buffers = _context3.sent;

                                buffers.forEach(function (buffer) {
                                    var newBuffer = _this2.state.addBuffer(bncNetwork.id, buffer.name);
                                    if (buffer.joined) {
                                        newBuffer.enabled = true;
                                        newBuffer.joined = true;
                                    } else {
                                        newBuffer.enabled = false;
                                        newBuffer.joined = false;
                                    }
                                    if (buffer.seen) {
                                        newBuffer.last_read = new Date(buffer.seen).getTime();
                                    }

                                    newBuffer.topic = buffer.topic || '';

                                    if (bncNetwork.state === 'connected' && newBuffer.isChannel() && newBuffer.joined) {
                                        client.raw('NAMES ' + newBuffer.name);
                                    }
                                });

                                bncNetwork.buffers.forEach(function (clientBuffer) {
                                    if (!clientBuffer.isChannel() && !clientBuffer.isQuery()) {
                                        return;
                                    }

                                    var existingBuffers = buffers.filter(function (bncBuffer) {
                                        return bncBuffer.name.toLowerCase() === clientBuffer.name.toLowerCase();
                                    });

                                    if (existingBuffers.length === 0) {
                                        _this2.state.removeBuffer(clientBuffer);
                                    }
                                });

                            case 6:
                            case 'end':
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function syncBncNetwork(_x4) {
                return _ref3.apply(this, arguments);
            }

            return syncBncNetwork;
        }()
    }, {
        key: 'addNetworkToState',
        value: function () {
            var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(network) {
                var net;
                return _regenerator2.default.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                net = this.state.getNetworkFromBncName(network.name);

                                if (!net) {
                                    net = this.state.addNetwork(network.name, network.nick || '', {
                                        server: network.host,
                                        port: network.port,
                                        tls: network.tls,
                                        password: network.password,
                                        bncname: network.name,
                                        username: network.user
                                    });
                                }

                                _context4.next = 4;
                                return this.syncBncNetwork(net);

                            case 4:
                            case 'end':
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function addNetworkToState(_x5) {
                return _ref4.apply(this, arguments);
            }

            return addNetworkToState;
        }()
    }, {
        key: 'snapshotCurrentNetworks',
        value: function snapshotCurrentNetworks() {
            var _this3 = this;

            this.networksSnapshot = (0, _create2.default)(null);

            this.state.networks.forEach(function (network) {
                if (!network.connection.bncname) {
                    return;
                }

                _this3.networksSnapshot[network.connection.bncname] = {
                    name: network.connection.bncname,
                    host: network.connection.server,
                    port: network.connection.port,
                    tls: network.connection.tls,
                    password: network.password,
                    nick: network.connection.nick,
                    username: network.username
                };
            });
        }
    }, {
        key: 'saveState',
        value: function saveState() {
            var _this4 = this;

            var controller = this.getController();
            if (!controller) {
                log('No controller available to save networks');
                return;
            }

            this.state.networks.forEach(function (network) {
                if (_this4.getController() === network && !network.ircClient.bnc.hasNetwork()) {
                    return;
                }

                var bncName = network.connection.bncname;
                var snapshot = _this4.networksSnapshot[bncName] || {};
                var tags = {};

                if (network.connection.server !== snapshot.host) {
                    tags.host = network.connection.server;
                }
                if (network.connection.port !== snapshot.port) {
                    tags.port = network.connection.port;
                }
                if (network.connection.tls !== snapshot.tls) {
                    tags.tls = network.connection.tls;
                }
                if (network.password !== snapshot.password) {
                    tags.password = network.password;
                }
                if (network.connection.nick !== snapshot.nick) {
                    tags.nick = network.connection.nick;
                }
                if (network.username !== snapshot.username) {
                    tags.user = network.username;
                }

                if (!snapshot.name && tags.host && tags.port && tags.nick) {
                    network.connection.bncname = network.name;
                    controller.ircClient.bnc.addNetwork(network.name, tags.host, tags.port, tags.tls, tags.nick, tags.user, tags.password);
                } else if (snapshot.name) {
                    controller.ircClient.bnc.saveNetwork(bncName, tags);
                }
            });

            this.snapshotCurrentNetworks();
        }
    }, {
        key: 'monitorNetworkChanges',
        value: function monitorNetworkChanges() {
            this.snapshotCurrentNetworks();

            var debouncedSaveState = _lodash2.default.debounce(this.saveState.bind(this), 2000);
            this.state.$watch('networks', debouncedSaveState, { deep: true });
        }
    }, {
        key: 'listenToState',
        value: function listenToState() {
            var _this5 = this;

            var state = this.state;

            state.$on('network.connecting', function (event) {
                var network = event.network;
                if (_this5.bnc.enabled && _this5.rewriteConnections) {
                    var netname = network.connection.bncname;

                    var ircClient = network.ircClient;
                    ircClient.options.host = _this5.bnc.server;
                    ircClient.options.port = _this5.bnc.port;
                    ircClient.options.tls = _this5.bnc.tls;

                    if (_this5.bnc.password) {
                        var password = _this5.bnc.username + '/' + netname + ':' + _this5.bnc.password;
                        ircClient.options.password = password;
                    }

                    network.connection.direct = _this5.bnc.direct;
                    ircClient.options.path = _this5.bnc.path;
                }
            });
            state.$on('network.connecting', function (event) {
                var controller = _this5.getController();
                if (!controller) {
                    log('No controller available to save network states');
                    return;
                }

                _this5.saveState();

                var network = event.network;

                if (network.connection.bncname) {
                    controller.ircClient.raw('BOUNCER connect ' + network.connection.bncname);
                }
            });
            state.$on('irc.motd', function (event, network) {
                network.buffers.forEach(function (buffer) {
                    if (buffer.isChannel() && buffer.enabled && buffer.joined) {
                        network.ircClient.who(buffer.name);
                    }
                });
            });

            state.$on('network.new', function (event) {
                var network = event.network;

                network.ircClient.use((0, _BouncerMiddleware2.default)());

                if (!network.connection.bncname) {
                    var currentNum = 1;
                    var existingNet = true;
                    while (existingNet) {
                        existingNet = _lodash2.default.find(state.networks, {
                            name: 'Network' + currentNum
                        });
                        existingNet = existingNet || _lodash2.default.find(state.networks, {
                            connection: { bncname: 'Network' + currentNum }
                        });

                        if (!existingNet || network === existingNet) {
                            network.name = 'Network' + currentNum;
                            existingNet = null;
                        }

                        currentNum++;
                    }
                }
            });

            state.$on('network.removed', function (event) {
                var controller = _this5.getController();
                if (!controller) {
                    log('No controller available to save network states');
                    return;
                }

                if (event.network.connection.bncname) {
                    controller.ircClient.bnc.removeNetwork(event.network.connection.bncname);
                }
            });

            state.$on('buffer.close', function (event) {
                var buffer = event.buffer;
                var network = event.buffer.getNetwork();
                var bncName = network.connection.bncname;

                var controller = _this5.getController();
                if (!controller) {
                    log('No controller available to save buffer states');
                    return;
                }

                if (bncName) {
                    controller.ircClient.bnc.closeBuffer(bncName, buffer.name);
                }
            });
        }
    }]);
    return BouncerProvider;
}();

exports.default = BouncerProvider;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
window._kiwi_exports["libs"]["BouncerProvider"]
window._kiwi_exports.libs.BouncerProvider = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./src/libs/BouncerProvider.js
// module id = kSJ/
// module chunks = 1